import { styled } from "@mui/material/styles";

export const Root = styled("div")({
  minHeight: "100vh",
  display: "grid",
  gridTemplateColumns: "1fr",
  gridTemplateRows: "auto 1fr auto",
});

export const globalStyles = (theme) => ({
  "*": {
    minWidth: 0,
    minHeight: 0,
  },
  "#simple-popper": {
    zIndex: theme.zIndex.tooltip,
  },
});
